export const ENGLISH_TRANSLATIONS = {
    'a11y': {
        'show' : 'Show',
        'hide': 'Hide'
    },
    'router': {
        'back-to-start': 'Go back to start'
    },
    'button': {
        'toggle-map': 'Toggle map',
        'return-back': 'Back to question',
        'save-draft': 'Save as a draft',
        'send-answers': 'Send',
        'next': 'Next',
        'copy-draft-link': 'Copy',
        'copy-draft-link-copied': 'Copied!',
        'show-results': 'Show results',
        'cancel': "Cancel",
        'send': "Send",
        'print': 'Tulosta'
    },
    'draft-form': {
        'input': {
            'draft-password': "Luonnoksen salasana",
            'draft-email': 'Sähköposti (vapaaehtoinen)',
        },
        'info': {
            'draft-password': 'Anna salasana, joka on vähintään kuusi merkkiä pitkä ja sisältää yhden ison kirjaimen ja numeron',
            'draft-email': 'Anna sähköpostiosoite, johon lähetetään linkki kyselyn jatkamista varten',
            'draft-email-extra': 'Sähköpostiosoitetta ei tallenneta järjestelmään.',
            'give-password': 'Anna salasana'
        },
        'validation': {
            'password-missing': 'Salasana puuttuu',
            'password-invalid': 'Anna salasana, joka on vähintään kuusi merkkiä pitkä ja sisältää yhden ison kirjaimen ja numeron',
            'email-invalid': "Anna sähköposti muodossa etunimi.sukunimi{'@'}email.fi",
            'password-failed': "Kokeile antaa salasana uudestaan"
        }
    },
    'end-of-path': {
        'continue': 'Pääsit kyselyn tämän vaiheen loppuun. Voit jatkaa kyselyn vastaamattomiin osioihin alla olevien painikkeiden avulla.',
        'save-or-send': 'Vaihtoehtoisesti voit myös jatkaa kyselyn täyttämistä myöhemmin painamalla Tallenna luonnoksena -painiketta tai päättää kyselyyn vastaamisen painamalla Katso tulokset -painiketta.',
        'completed': 'Kysely on täytetty kokonaisuudessaan.'
    },
    'table': {
        'question': 'Osion otsikko tai kysymys',
        'answers': 'Vastaukset',
        'points': 'Pisteet',
        'clicked': '',
        'completion': 'Kyselystä on täytetty',
        'max-weight': "Pisteiden maksimimäärä",
        'total': 'Yhteensä',
        'plain-question': 'Kysymys'
    },
    'survey-stages-left': 'Jatka kyselyyn vastaamista valitsemalla uusi kysymys alla olevista painikkeista.',
    'survey-progress-percent': 'Kyselyn etenemisprosentti',
    'survey-progress-current-stage': 'Vastauksia annettu',
    'survey-progress-total-stages': 'Vaiheita yhteensä',
    'svg-map-title': 'Karttanäkymä kyselyn vaiheista',
    'points': 'pistettä',
    'total-points': 'Kokonaispisteet',
    'survey-max-points': 'maksimi',
    'topic': 'Osio',
    'move-to-stage': 'Siirry kyselyn seuraavaan vaiheeseen',
    'answer-given': 'Vastaus annettu',
    '404-message': '404 - Not found',
    'thank-you-message': 'Kiitos vastauksestasi!',
    'saved-as-a-draft-message': 'Kysely on nyt tallennettu luonnoksena. Luonnoksen voi avata annetulla salasanalla osoitteessa',
    'form-steps': 'Lomakkeen vaiheet',
    'confirm-submit-info': 'Haluatko katsoa tulokset. Tulossivulla näet vastaustesi pistemäärän aihealueittain sekä listauksen niistä aihealueista, joissa on vielä kehitettävää oman kuntasi sisäilma-asioiden hoidossa.',
    'improving-topics': 'Seuraavissa aihealueissa on kehitettävää',
    'total-points-per-topic': 'Kokonaispistemääräsi: ',
    'survey-result-view-text-1': 'Vastaustesi pistemäärät aihealueittain:',
    'survey-result-view-text-2': 'Terveet tilat -toimintamallista löytyy tietoa, ohjeita ja hyviä käytäntöjä kyselyn kaikkiin aihealueisiin. Löytyisikö toimintamallista apua sinun kunnallesi? Kannattaa tutustua!',
    'survey-result-view-text-3': 'Terveet tilat -toimintamalli (',
    'modal': {
        'close': 'Sulje'
    },
    'actions': {
        'check-answers': "Voit katsoa tästä vastauksiasi"
    },
    'review-text-pos': "Onneksi olkoon! Vastaustesi perusteella vaikuttaa siltä, että kuntanne sisäilma-asiat ovat hyvällä mallilla ja kunnassanne on selvästi tehty töitä hyvän sisäilman eteen. Alta löydät vielä listauksen niistä osa-alueista, joissa voi olla vielä hieman parannettavaa.",
    'review-text-med': "Vastaustesi perusteella vaikuttaa siltä, että kuntanne on huomioinut sisäilma-asioita, mutta vielä on jonkin verran parannettavaa. Alta löydät listauksen niistä kaikista osa-alueista, joihin kannattaa tulevina vuosina kiinnittää huomiota.",
    'review-text-neg': "Vastaustesi perusteella vaikuttaa siltä, että kunnassanne ei ole vielä riittävästi huomioitu sisäilma-asioita kunnan toiminnassa. Alta löytyvän listauksen avulla voitte yhdessä lähteä kehittämään kuntanne toimintaa sisäilma-asioiden edistämiseksi."
}